var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,_vm._g({tag:"component",class:[
    // Base
    'v-card',

    // Background variant
    _vm.overlay && _vm.bgVariantOutput.class && `bg-${_vm.bgVariantOutput.class}`,

    // Overlay
    {
      'v-card--overlay': _vm.overlay
    },

    // Elevated
    {
      'v-card--elevated': _vm.elevated
    },

    // Animation
    {
      'v-card--animate-from': _vm.animation.enabled,
      'v-card--animate-to': _vm.animation.started
    },

    // Image position
    {
      // Small breakpoint
      'flex-column': !_vm.imgPosition || (_vm.imgPosition === 'top' && !_vm.noSplit),
      'flex-row': _vm.imgPosition === 'left',
      'flex-row-reverse': _vm.imgPosition === 'right' || _vm.noSplit,

      // Medium breakpoint
      'flex-md-column': _vm.imgMdPosition === 'top',
      'flex-md-row': _vm.imgMdPosition === 'left',
      'flex-md-row-reverse': _vm.imgMdPosition === 'right',

      // Large breakpoint
      'flex-lg-column': _vm.imgLgPosition === 'top',
      'flex-lg-row': _vm.imgLgPosition === 'left',
      'flex-lg-row-reverse': _vm.imgLgPosition === 'right'
    }
  ],style:([_vm.animation.enabled && { transitionDelay: _vm.animation.delay }])},_vm.$listeners),[(!!_vm.imgSrc)?_c('div',{directives:[{name:"waypoint",rawName:"v-waypoint",value:({
      active: !_vm.seen,
      callback: _vm.onWaypoint,
      options: _vm.intersectionOptions
    }),expression:"{\n      active: !seen,\n      callback: onWaypoint,\n      options: intersectionOptions\n    }"}]}):_vm._e(),(_vm.overlay)?_c('div',{class:[
      'v-card__overlay',
      _vm.imgLoaded && 'v-card__overlay--show',
      { 'v-card__overlay--show--noSplit': _vm.noSplit }
    ],style:({
      backgroundImage: !!_vm.imgSrc && _vm.imgLoaded && `url('${_vm.imgSrc}')`,
      backgroundPosition: !!_vm.imgAlign && _vm.imgAlign
    })},[(!!_vm.imgSrc)?_c('div',{class:[
        'v-card__overlay__color-1',
        _vm.bgVariantOutput.class && `text-${_vm.bgVariantOutput.class}`
      ],style:({
        color: _vm.bgVariantOutput.color,
        backgroundImage:
          !!_vm.imgSrc &&
          `linear-gradient(90deg, currentColor, currentColor 5%, rgba(${_vm.bgVariantOutput.gradientRgb},0))`,
        backgroundPosition: !!_vm.imgAlign && _vm.imgAlign
      })}):_vm._e(),(!!_vm.imgSrc)?_c('div',{class:[
        'v-card__overlay__color-2',
        _vm.bgVariantOutput.class && `text-${_vm.bgVariantOutput.class}`
      ],style:({
        color: _vm.bgVariantOutput.color,
        backgroundImage:
          !!_vm.imgSrc &&
          `linear-gradient(-180deg, currentColor, currentColor 5%, rgba(${_vm.bgVariantOutput.gradientRgb},0))`,
        backgroundPosition: !!_vm.imgAlign && _vm.imgAlign
      })}):_vm._e()]):_vm._e(),(!!_vm.imgSrc)?_c('div',{class:[
      'v-card__image--wrapper',
      !_vm.overlay && _vm.bgVariantOutput.class && `bg-${_vm.bgVariantOutput.class}`,
      { 'v-card__image--wrapper--noSplit': _vm.noSplit }
    ]},[_c('picture',{class:[
        'v-card__image',
        'v-card__image__default',
        _vm.imgLoaded && 'v-card__image--show'
      ]},[_c('source',{attrs:{"media":"(min-width:380px)","srcset":_vm.imgSrc}}),_c('source',{attrs:{"media":"(min-width:1080px)","srcset":_vm.imgMdSrc}}),_c('img',{staticClass:"v-card__image-component",attrs:{"src":_vm.imgSrc,"alt":_vm.alt}})]),(_vm.video && _vm.imgLoaded)?_c('div',{staticClass:"v-card__image--wrapper__video-overlay",class:{
        'v-card__image--wrapper__video-overlay--no-overlay': _vm.overlay
      }},[_c('v-icon',{staticClass:"v-card__image--wrapper__video-overlay__icon",attrs:{"name":"play-button","width":"45"}})],1):_vm._e()]):_vm._e(),_c('div',{class:[
      'v-card__content',
      !_vm.overlay && _vm.bgVariantOutput.class && `bg-${_vm.bgVariantOutput.class}`
    ],style:([
      !_vm.imgSrc && { height: '100%' },
      { backgroundColor: _vm.bgVariantOutput.color }
    ])},[_c('div',{staticClass:"v-card__content__relative"},[(_vm.tooltip)?_c('v-infoicon',{attrs:{"tooltip":_vm.tooltip,"placement":_vm.tooltipPlacement}}):_vm._e()],1),_c('div',{class:[
        !!_vm.padding && _vm.padding,
        'h-100',
        'v-card__content--inner',
        { 'py-3 py-md-5': !!_vm.imgSrc && !_vm.padding }
      ]},[_c('div',{staticStyle:{"display":"flex","height":"100%"}},[_c('div',{staticStyle:{"flex":"1","height":"100%","max-width":"100%"}},[_vm._t("default")],2)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }